import OadpTableColumn from './oadp-table-column';
export default OadpTableColumn;
